import React, { useState, useEffect } from 'react'
import NavigacijaPasirinkimas from '../components/NavigacijaPasirinkimas'
import { getNavigacija, setNavigacija, NAVIGACIJOS } from '../utils/navigacija'
import { atstatytiOnboarding } from '../utils/onboarding'
import { isvalytiKelioniuDuomenis } from '../utils/duomenys'

const APP_VERSIJA = '1.0.0 · beta'

function Sekcija({ pavadinimas, children }) {
  return (
    <div style={{ marginBottom: 22 }}>
      <div style={{ color: '#7A8A7E', fontSize: 10, letterSpacing: '0.1em', textTransform: 'uppercase', margin: '0 4px 8px' }}>{pavadinimas}</div>
      <div style={{ background: '#1E2E27', border: '1px solid #2A3B32', borderRadius: 14, overflow: 'hidden' }}>{children}</div>
    </div>
  )
}

function Eilute({ ikona, tekstas, antra, desine, onClick, spalva = '#F0E8D5', paskutine }) {
  return (
    <button
      onClick={onClick}
      disabled={!onClick}
      style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%', textAlign: 'left', padding: '14px 16px', background: 'transparent', border: 'none', borderBottom: paskutine ? 'none' : '1px solid #2A3B32', cursor: onClick ? 'pointer' : 'default', fontFamily: 'Syne, system-ui, sans-serif' }}
    >
      <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke={spalva === '#F0E8D5' ? '#7A8A7E' : spalva} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>{ikona}</svg>
      <span style={{ flex: 1, minWidth: 0 }}>
        <span style={{ display: 'block', color: spalva, fontSize: 14 }}>{tekstas}</span>
        {antra && <span style={{ display: 'block', color: '#7A8A7E', fontSize: 11.5, marginTop: 2 }}>{antra}</span>}
      </span>
      {desine}
    </button>
  )
}

const IK = {
  nav: <><path d="M9 4L3 6v14l6-2 6 2 6-2V4l-6 2-6-2z" /><line x1="9" y1="4" x2="9" y2="18" /><line x1="15" y1="6" x2="15" y2="20" /></>,
  akis: <><path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7z" /><circle cx="12" cy="12" r="3" /></>,
  sluota: <><path d="M3 21l6-6" /><path d="M14 4l6 6-7 3-2-2 3-7z" /><path d="M9 15l-1 4 4-1" /></>,
  info: <><circle cx="12" cy="12" r="10" /><path d="M12 16v-4M12 8h.01" /></>,
  chevron: <path d="M9 18l6-6-6-6" />,
}

function NustatymaiEkranas({ atidaryta, onClose, onToast }) {
  const [nav, setNav] = useState(() => getNavigacija())
  const [navPasirinkimas, setNavPasirinkimas] = useState(false)
  const [valymoPatvirtinimas, setValymoPatvirtinimas] = useState(false)

  useEffect(() => { if (atidaryta) { setNav(getNavigacija()); setValymoPatvirtinimas(false) } }, [atidaryta])

  const navPav = nav ? (NAVIGACIJOS.find(n => n.id === nav) || {}).pavadinimas : 'Nepasirinkta'

  function perziuretiApzvalga() {
    atstatytiOnboarding()
    if (onToast) onToast('Apžvalga bus parodyta iš naujo')
    setTimeout(() => window.location.reload(), 700)
  }

  function isvalyti() {
    if (!valymoPatvirtinimas) { setValymoPatvirtinimas(true); return }
    isvalytiKelioniuDuomenis()
    if (onToast) onToast('Duomenys išvalyti')
    setTimeout(() => window.location.reload(), 700)
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#141F1A', zIndex: 1001, transform: atidaryta ? 'translateX(0)' : 'translateX(100%)', transition: 'transform 340ms cubic-bezier(0.32,0.72,0,1)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: 'calc(14px + env(safe-area-inset-top)) 16px 8px', flexShrink: 0 }}>
        <button onClick={onClose} aria-label="Atgal" style={{ width: 34, height: 34, borderRadius: '50%', border: '1px solid #3A4C42', background: 'transparent', color: '#F0E8D5', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
        <span style={{ fontFamily: "'Lora', Georgia, serif", color: '#F0E8D5', fontSize: 19 }}>Nustatymai</span>
        <div style={{ width: 34 }} />
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '12px 16px calc(28px + env(safe-area-inset-bottom))' }}>
        <Sekcija pavadinimas="Navigacija">
          <Eilute
            ikona={IK.nav}
            tekstas="Navigacijos programa"
            antra={navPav}
            onClick={() => setNavPasirinkimas(true)}
            paskutine
            desine={<span style={{ color: '#7A8A7E', fontSize: 12, display: 'flex', alignItems: 'center', gap: 4 }}>Keisti <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">{IK.chevron}</svg></span>}
          />
        </Sekcija>

        <Sekcija pavadinimas="Apžvalga">
          <Eilute ikona={IK.akis} tekstas="Peržiūrėti apžvalgą iš naujo" antra="Rodys užuominas kaip pirmą kartą" onClick={perziuretiApzvalga} paskutine />
        </Sekcija>

        <Sekcija pavadinimas="Duomenys">
          <Eilute
            ikona={IK.sluota}
            tekstas={valymoPatvirtinimas ? 'Tikrai išvalyti? Paspausk dar kartą' : 'Išvalyti mano duomenis'}
            antra={valymoPatvirtinimas ? 'Aplankytos, prisiminimai ir nuotraukos bus ištrinti visam' : 'Aplankytos vietos, prisiminimai, nuotraukos'}
            spalva="#C86353"
            onClick={isvalyti}
            paskutine
          />
        </Sekcija>

        <Sekcija pavadinimas="Apie">
          <Eilute ikona={IK.info} tekstas="Versija" desine={<span style={{ color: '#7A8A7E', fontSize: 13 }}>{APP_VERSIJA}</span>} paskutine />
        </Sekcija>

        <p style={{ color: '#5A6558', fontSize: 11, textAlign: 'center', marginTop: 8, lineHeight: 1.5 }}>
          Kelionių App · viskas saugoma tavo įrenginyje.<br />Paskyra ir sinchronizacija — netrukus.
        </p>
      </div>

      <NavigacijaPasirinkimas
        atidaryta={navPasirinkimas}
        dabartine={nav}
        onPasirinkti={(id) => { setNavigacija(id); setNav(id); setNavPasirinkimas(false); if (onToast) onToast('Navigacija pakeista') }}
        onClose={() => setNavPasirinkimas(false)}
      />
    </div>
  )
}

export default NustatymaiEkranas
